import { useLocation } from 'js/lib/useRouter';

import { ENTERPRISE_ADMIN_COACH_REF } from 'bundles/enterprise-admin-constants/EnterpriseCoachConstants';
import { getPendingAdminCoachActionCompletion } from 'bundles/enterprise-admin-hooks/utils/adminCoachActionCompletionStorage';
import { useThirdPartyOrganization } from 'bundles/enterprise-admin/ThirdPartyOrganizationProvider';

/**
 * Returns the Admin Coach chat message id for the current flow, or `undefined` when it does not apply.
 *
 * The id is only surfaced when the flow was launched from the Admin Coach (`ref=admin-coach`) and a
 * pending coach action for the current organization exists in sessionStorage. Consumers typically use
 * it to tie a tracking event back to the originating chat message (e.g. `coach.chatMessageId`).
 */
export const usePendingAdminCoachMessageId = (): string | undefined => {
  const { query } = useLocation();
  const thirdPartyOrganization = useThirdPartyOrganization();

  const isFromAdminCoach = query?.ref === ENTERPRISE_ADMIN_COACH_REF;
  if (!isFromAdminCoach) return undefined;

  return getPendingAdminCoachActionCompletion(thirdPartyOrganization?.id ?? '')?.messageId;
};

export default usePendingAdminCoachMessageId;
